import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    error: null,
    toolsMoodsData: [],
    toolsThoughtsData: null,
    toolsAverageData: null,
    topUsageData: {}
}

export const tools = createSlice({
    name: 'tools',
    initialState,
    reducers: {
        toolsMoodsLoggedLoad: (state) => {
            state.loading = true;
            state.error = false;
        },
        toolsMoodsLoggedSuccess: (state, action) => {
            state.loading = false;
            state.toolsMoodsData = action.payload;
        },
        toolsMoodsLoggedFailed: state => {
            state.loading = false;
        },

        toolsThoughtsLoggedLoad: state => {
            state.loading = true;
        },
        toolsThoughtsLoggedSuccess: (state, action) => {
            state.loading = false;
            state.toolsThoughtsData = action.payload;
        },
        toolsThoughtsLoggedFailed: state => {
            state.loading = false;
        },

        toolsAverageMoodLoad: state => {
            state.loading = true;
        },
        toolsAverageMoodSuccess: (state, action) => {
            state.loading = false;
            state.toolsAverageData = action.payload;
        },
        toolsAverageMoodFail: state => {
            state.loading = false;
        },

        toolsTopUsageLoad: state => {
            state.loading = true;
        },

        toolsTopUsageSuccess: (state, action) => {
            state.loading = false;
            state.topUsageData = action.payload.data
        },

        toolsTopUsageFail: state => {
            state.loading = true;
        },
    }
});

export const {

    toolsMoodsLoggedLoad,
    toolsMoodsLoggedSuccess,
    toolsMoodsLoggedFailed,

    toolsThoughtsLoggedLoad,
    toolsThoughtsLoggedSuccess,
    toolsThoughtsLoggedFailed,

    toolsAverageMoodLoad,
    toolsAverageMoodSuccess,
    toolsAverageMoodFail,

    toolsTopUsageLoad,
    toolsTopUsageFail,
    toolsTopUsageSuccess

} = tools.actions;
export default tools.reducer;